<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.back()"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("stadistics.backbtn") }}</span>
    </v-tooltip>

    <v-carousel
      width="100%"
      id="stadistics-0"
      v-if="$store.getters['auth/isMetric']"
      class="mt-12"
      :hide-delimiters="$vuetify.breakpoint.smAndDown"
      :hide-delimiter-background="$vuetify.theme.dark"
    >
      <v-carousel-item width="100%" v-if="equipmentProfile.pumpHousing">
        <div class="title">{{ $t("stadistics.pumpHousingC") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapPumpHousing"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI11"
      >
        <div class="title">{{ $t("stadistics.mapCFSBar11") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapCFSBar11"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI23"
      >
        <div class="title">
          {{ $t("stadistics.mapSHTc") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapSHTc"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI23"
      >
        <div class="title">{{ $t("stadistics.mapSHPbar") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapSHPbar"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI23"
      >
        <div class="title">
          {{ $t("stadistics.mapFITc") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapFITc"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI23"
      >
        <div class="title">
          {{ $t("stadistics.mapCwTc") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapCwTc"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI32"
      >
        <div class="title">{{ $t("stadistics.mapfCTc") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfCTc"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI32"
      >
        <div class="title">{{ $t("stadistics.mapfCbar") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfCbar"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">
          {{ $t("stadistics.mapCwInOut52") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapCwInOut52"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">{{ $t("stadistics.mapOilInOut52") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapOilInOut52"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">{{ $t("stadistics.mapShPbar52") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapShPbar52"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">{{ $t("stadistics.mapPBar52") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapPBar52"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">
          {{ $t("stadistics.mapTankLevel52") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapTankLevel52"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">{{ $t("stadistics.mapIaPbar53b") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapIaPbar53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">{{ $t("stadistics.mapSysPbar53b") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapSysPbar53b"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">{{ $t("stadistics.mapcBpiBpoTc53b") }}</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapcBpiBpoTc53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.mapfBpiBpoTc53b") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfBpiBpoTc53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.mapcBpiBpoBar53b") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapcBpiBpoBar53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.mapcBpiBpoBar53b") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfBpiBpoBar53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
        ><div class="title">
          {{ $t("stadistics.mapcCwInOut53b") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapcCwInOut53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
        ><div class="title">
          {{ $t("stadistics.mapfCwInOut53b") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfCwInOut53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
        ><div class="title">
          {{ $t("stadistics.mapFCRs53b") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapFCRs53b"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.mapBpiBpoTc54") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapBpiBpoTc54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.mapBpiBpoTc54") }}
        </div>
        <div class="title">)</div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapBpiBpoPbar54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.mapCwInOut54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapCwInOut54"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.mapFlowL54") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapFlowL54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
        ><div class="title">
          {{ $t("stadistics.mapMotorTc54") }}
        </div>
        <div class="title"></div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapMotorTc54"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.mapTankLevel54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapTankLevel54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.mapfBpiBpoTc54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfBpiBpoTc54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.mapfBpiBpoPbar54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfBpiBpoPbar54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.mapfCwInOut54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfCwInOut54"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.mapfFlowL54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfFlowL54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.mapfMotorTc54") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfMotorTc54"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.mapfTankLevel54") }}
        </div>
        <div class="title"></div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfTankLevel54"
        ></apexchart>
      </v-carousel-item>
    </v-carousel>
    <v-carousel
      v-else
      class="mt-12"
      hide-delimiter-background=""
      :hide-delimiters="$vuetify.breakpoint.smAndDown"
    >
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.pumpHousing"
      >
        <div class="title">
          {{ $t("stadistics.imapPumpHousing") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapPumpHousing"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI11"
      >
        <div class="title">
          {{ $t("stadistics.imapCFSpsi11") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapCFSpsi11"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI23"
      >
        <div class="title">
          {{ $t("stadistics.imapSHTc") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapSHTc"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI23"
      >
        <div class="title">
          {{ $t("stadistics.imapSHPbar") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapSHPbar"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI23"
      >
        <div class="title">
          {{ $t("stadistics.imapFITc") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapFITc"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI23"
      >
        <div class="title">
          {{ $t("stadistics.imapCwTc") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapCwTc"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI32"
      >
        <div class="title">
          {{ $t("stadistics.imapfCTf") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfCTf"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI32"
      >
        <div class="title">
          {{ $t("stadistics.mapfCpsi") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="mapfCpsi"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">
          {{ $t("stadistics.imapCwInOut52") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapCwInOut52"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">
          {{ $t("stadistics.imapOilInOut52") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapOilInOut52"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">
          {{ $t("stadistics.imapShPbar52") }}
        </div>
        <div class="title"></div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapShPbar52"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">
          {{ $t("stadistics.imapPBar52") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapPBar52"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI52"
      >
        <div class="title">
          {{ $t("stadistics.imapTankLevel52") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapTankLevel52"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.imapIaPbar53b") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapIaPbar53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.imapSysPbar53b") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapSysPbar53b"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.imapcBpiBpoTc53b") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapcBpiBpoTc53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.imapfBpiBpoTc53b") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfBpiBpoTc53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.imapcBpiBpoBar53b") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapcBpiBpoBar53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.imapfBpiBpoBar53b") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfBpiBpoBar53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.imapcCwInOut53b") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapcCwInOut53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.imapfCwInOut53b") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfCwInOut53b"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI53b"
      >
        <div class="title">
          {{ $t("stadistics.imapFCRs53b") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapFCRs53b"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.imapBpiBpoTc54") }}
        </div>
        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapBpiBpoTc54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.imapBpiBpoPbar54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapBpiBpoPbar54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.imapCwInOut54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapCwInOut54"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.imapFlowL54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapFlowL54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.imapMotorTc54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapMotorTc54"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="equipmentProfile.planAPI.planAPI54"
      >
        <div class="title">
          {{ $t("stadistics.imapTankLevel54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapTankLevel54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.imapfBpiBpoTc54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfBpiBpoTc54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.imapfBpiBpoPbar54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfBpiBpoPbar54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.imapfCwInOut54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfCwInOut54"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.imapfFlowL54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfFlowL54"
        ></apexchart>
      </v-carousel-item>
      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.imapfMotorTc54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfMotorTc54"
        ></apexchart>
      </v-carousel-item>

      <v-carousel-item
        width="100%"
        height="auto"
        v-if="
          equipmentProfile.planAPI.planAPI54 &&
            equipmentProfile.equipType === 'BB'
        "
      >
        <div class="title">
          {{ $t("stadistics.imapfTankLevel54") }}
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options"
          :series="imapfTankLevel54"
        ></apexchart>
      </v-carousel-item>
    </v-carousel>

    <v-card class="mt-12">
      <v-card-title
        id="stadistics-3"
        class="white--text d-flex justify-center text-center primary"
      >
        {{ $t("stadistics.commentList") }} - <br class="hidden-md-and-up" />
        {{ $route.params.equipTag }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        sort-by="dateCreated"
        :loading="Object.entries(measurements).length === 0"
        loading-text="Loading... Please wait"
        :headers="headers"
        :items="measurements"
      >
        <template v-slot:item.dateCreated="{ item }">
          {{ item.dateCreated | FixingDate }}
        </template></v-data-table
      >
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
export default {
  components: {},
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch(
      "inspections/bindAStatitics",
      this.$route.params.id
    );
    await this.$store.dispatch(
      "equipments/bindAnEquipment",
      this.$route.params.id
    );
    loading.close();
  },

  data() {
    var self = this;
    return {
      headers: [
        { text: self.$t("stadistics.inspectionDate"), value: "dateCreated" },

        { text: self.$t("stadistics.comment"), value: "comment" }
      ]
    };
  },
  //$}
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("inspections", ["measurements"]),
    ...mapGetters("auth", ["isSuperAdmin"]),
    options() {
      return {
        chart: {
          background: this.$vuetify.theme.dark ? "#000000" : "#FFFFFF",
          id: "Metax-app"
        },

        xaxis: {
          type: "datetime",
          labels: {
            format: "dd/MM/yyyy"
          }
        },

        theme: {
          mode: this.$vuetify.theme.dark ? "dark" : "light",
          palette: "palette7"
        },
        noData: {
          text: "There is no data for this API",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "14px",
            fontFamily: undefined
          }
        }
      };
    },
    /* PARA METRICOS */
    mapPumpHousing() {
      let tempC = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.pumpHousing.tempC];
      });
      return [{ name: "Pump Housing Temperature (°C) ", data: tempC }];
    },
    mapCFSBar11() {
      let cPbar11 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI11.cPbar11];
      });
      let fPbar11 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI11.fPbar11];
      });
      return [
        { name: "API 11 In Board – Pressure (bar)", data: cPbar11 },
        {
          name: "API 11 Out Board – Pressure (bar)",
          data: fPbar11
        }
      ];
    },
    mapSHTc() {
      let shTc23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.shTc23];
      });
      return [{ name: "API 23 Stuffing Box Temperature (°C)", data: shTc23 }];
    },
    mapSHPbar() {
      let shPbar23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.shPbar23];
      });
      return [{ name: "API 23 Stuffing Box Pressure (bar)", data: shPbar23 }];
    },
    mapFITc() {
      let fiTc23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.fiTc23];
      });
      return [{ name: "API 23 FI Temperature (°C) ", data: fiTc23 }];
    },
    mapCwTc() {
      let cwTinC23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.cwTinC23];
      });
      let cwToutC23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.cwToutC23];
      });

      return [
        {
          name: "API 23 Cooling Water Out Temperature (°C) ",
          data: cwToutC23
        },
        { name: "API 23 Cooling Water In Temperature (°C) ", data: cwTinC23 }
      ];
    },
    mapfCTc() {
      let fiTcF32 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI32.fiTcF32];
      });
      let fiTcC32 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI32.fiTcC32];
      });
      return [
        { name: "API 32 Out Board Temperature (°C) ", data: fiTcF32 },
        { name: "API 32 In Board  Temperature (°C) ", data: fiTcC32 }
      ];
    },
    mapfCbar() {
      let fiPbarC32 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI32.fiPbarC32];
      });
      let fiPbarF32 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI32.fiPbarF32];
      });
      return [
        { name: "API 32 Out Board Pressure (bar) ", data: fiPbarF32 },
        { name: "API 32 In Board Pressure (bar) ", data: fiPbarC32 }
      ];
    },
    mapfCpsi() {
      let fiPbarC32 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI32.fiPpsiC32];
      });
      let fiPbarF32 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI32.fiPpsiF32];
      });
      return [
        { name: "API 32 Out Board Pressure (psi) ", data: fiPbarF32 },
        { name: "API 32 In Board Pressure (psi) ", data: fiPbarC32 }
      ];
    },
    mapCwInOut52() {
      let cwInTc52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.cwInTc52];
      });
      let cwOutTc52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.cwOutTc52];
      });
      return [
        {
          name: "API 52 Cooling Water Temperature (°C) In ",
          data: cwInTc52
        },
        {
          name: "API 52 Cooling Water Temperature (°C) Out",
          data: cwOutTc52
        }
      ];
    },
    mapOilInOut52() {
      let oilInTc52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.oilInTc52];
      });
      let oilOutTc52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.oilOutTc52];
      });
      return [
        {
          name: "API 52 Oil Temperature (°C) In",
          data: oilInTc52
        },
        {
          name: "API 52 Oil Temperature (°C) Out",
          data: oilOutTc52
        }
      ];
    },

    mapShPbar52() {
      let shPbar52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.shPbar52];
      });
      return [{ name: "API 52 Stuffing Box Pressure (bar)", data: shPbar52 }];
    },

    mapPBar52() {
      let pBar52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.pBar52];
      });
      return [{ name: "API 52 Pressure (bar)", data: pBar52 }];
    },

    mapTankLevel52() {
      let level52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.level52];
      });
      return [{ name: "API 52 Tank Level (mm)", data: level52 }];
    },

    mapIaPbar53b() {
      let iaPbar53b = this.measurements.map(function(obj) {
        return [
          obj.dateCreated.seconds * 1000,
          Math.round(obj.planAPI53b.iaPbar53b)
        ];
      });
      return [
        { name: "API 53B Instrument Air Pressure (bar)", data: iaPbar53b }
      ];
    },

    mapSysPbar53b() {
      let sysPbar53b = this.measurements.map(function(obj) {
        return [
          obj.dateCreated.seconds * 1000,
          Math.round(obj.planAPI53b.sysPbar53b)
        ];
      });
      return [{ name: "API 53B System Pressure (bar)", data: sysPbar53b }];
    },
    mapcBpiBpoTc53b() {
      let cBpiTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cBpiTc53b];
      });
      let cBpoTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cBpoTc53b];
      });
      return [
        {
          name: "API 53b In Board Bpo Temperature (°C)",
          data: cBpoTc53b
        },
        {
          name: "API 53b In Board Bpi Temperature (°C)",
          data: cBpiTc53b
        }
      ];
    },
    mapFCRs53b() {
      let fRsPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fRsPbar53b];
      });
      let cRsPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cRsPbar53b];
      });
      return [
        {
          name: "API 53b  Refilling Systems In Board - Pressure (bar)",
          data: fRsPbar53b
        },
        {
          name: "API 53b  Refilling Systems Out Board - Pressure (bar)",
          data: cRsPbar53b
        }
      ];
    },

    mapcBpiBpoBar53b() {
      let fBpoPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fBpoPbar53b];
      });
      let cBpoPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cBpoPbar53b];
      });
      return [
        {
          name: "API 53b Out Board Bpo Pressure (bar)",
          data: fBpoPbar53b
        },
        {
          name: "API 53b In Board Bpo Pressure (bar)",
          data: cBpoPbar53b
        }
      ];
    },

    mapcCwInOut53b() {
      let cCwOutTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cCwOutTc53b];
      });
      let cCwInTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cCwInTc53b];
      });
      return [
        {
          name: "API 53b In Board Cooling Water Temperature (°C) In ",
          data: cCwInTc53b
        },
        {
          name: "API 53b In Board Cooling Water Temperature (°C) Out",
          data: cCwOutTc53b
        }
      ];
    },
    mapfBpiBpoTc53b() {
      let fBpiTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fBpiTc53b];
      });
      let fBpoTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fBpoTc53b];
      });
      return [
        {
          name: "API 53b Out Board  Bpo Temperature (°C)",
          data: fBpoTc53b
        },
        {
          name: "API 53b Out Board  Bpi Temperature (°C)",
          data: fBpiTc53b
        }
      ];
    },

    mapfBpiBpoBar53b() {
      let fBpiPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fBpiPbar53b];
      });
      let fBpoPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fBpoPbar53b];
      });
      return [
        {
          name: "API 53b Out Board  Bpi Pressure (bar)",
          data: fBpiPbar53b
        },
        {
          name: "API 53b Out Board  Bpo Pressure (bar)",
          data: fBpoPbar53b
        }
      ];
    },

    mapfCwInOut53b() {
      let cFwInTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cFwInTc53b];
      });
      let cFwOutTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cFwOutTc53b];
      });
      return [
        {
          name: "API 53b Out Board Cooling Water Temperature (°C) In ",
          data: cFwInTc53b
        },
        {
          name: "API 53b Out Board  Cooling Water Temperature (°C) Out",
          data: cFwOutTc53b
        }
      ];
    },
    mapBpiBpoTc54() {
      let bpiTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.bpiTc54];
      });
      let bpoTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.bpoTc54];
      });
      return [
        {
          name: "API 54 In Board BPO – Temperature (°C) ",
          data: bpoTc54
        },
        {
          name: "API 54 In Board BPI – Temperature (°C) ",
          data: bpiTc54
        }
      ];
    },

    mapBpiBpoPbar54() {
      let bpoPbar54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.bpoPbar54];
      });
      let bpiPbar54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.bpiPbar54];
      });
      return [
        {
          name: "API 54 In Board BPO – Pressure (bar) ",
          data: bpoPbar54
        },

        {
          name: "API 54 In Board BPI – Pressure (bar) ",
          data: bpiPbar54
        }
      ];
    },
    mapCwInOut54() {
      let cwInTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.cwInTc54];
      });
      let cwOutTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.cwOutTc54];
      });
      return [
        {
          name: "API 54 In Board Cooling Water Temperature (°C) Out",
          data: cwOutTc54
        },
        {
          name: "API 54 In Board Cooling Water Temperature (°C) In ",
          data: cwInTc54
        }
      ];
    },

    mapFlowL54() {
      let flowLpm54 = this.measurements.map(function(obj) {
        return [
          obj.dateCreated.seconds * 1000,
          Math.round(obj.planAPI54.flowLpm54)
        ];
      });
      return [{ name: "API 54 In Board Flow (L/min)", data: flowLpm54 }];
    },
    mapTankLevel54() {
      let levelL54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.levelMm54];
      });
      return [{ name: "API 54 In Board Tank Level (mm)", data: levelL54 }];
    },
    mapMotorTc54() {
      let motorTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.motorTc54];
      });
      return [
        { name: "API 54 In Board Motor Temperature (°C)", data: motorTc54 }
      ];
    },
    mapfBpiBpoTc54() {
      let bpiTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fbpiTc54];
      });
      let bpoTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fbpoTc54];
      });
      return [
        {
          name: "API 54 Out Board  BPO – Temperature (°C) ",
          data: bpoTc54
        },

        {
          name: "API 54 Out Board  BPI – Temperature (°C) ",
          data: bpiTc54
        }
      ];
    },

    mapfBpiBpoPbar54() {
      let bpoPbar54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fbpoPbar54];
      });
      let bpiPbar54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fbpiPbar54];
      });
      return [
        {
          name: "API 54 Out Board  BPO – Pressure (bar) ",
          data: bpoPbar54
        },
        {
          name: "API 54 Out Board  BPI – Pressure (bar) ",
          data: bpiPbar54
        }
      ];
    },
    mapfCwInOut54() {
      let cwInTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fcwInTc54];
      });
      let cwOutTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fcwOutTc54];
      });
      return [
        {
          name: "API 54 Out Board  Cooling Water Temperature (°C) Out",
          data: cwOutTc54
        },
        {
          name: "API 54 Out Board  Cooling Water Temperature (°C) In ",
          data: cwInTc54
        }
      ];
    },

    mapfFlowL54() {
      let flowLpm54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fflowLpm54];
      });
      return [{ name: "API 54 Out Board  Flow (L/min)", data: flowLpm54 }];
    },
    mapfTankLevel54() {
      let levelMm54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.flevelMm54];
      });
      return [{ name: "API 54 Out Board  Tank Level (mm)", data: levelMm54 }];
    },
    mapfMotorTc54() {
      let motorTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fmotorTc54];
      });
      return [
        { name: "API 54 Out Board  Motor Temperature (°C)", data: motorTc54 }
      ];
    },

    /* PARA IMPERIAL */
    imapPumpHousing() {
      let tempC = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.pumpHousing.tempF];
      });
      return [{ name: "Pump Housing Temperature (°F) ", data: tempC }];
    },
    imapCFSpsi11() {
      let cPbar11 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI11.cPpsi11];
      });
      let fPbar11 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI11.fPpsi11];
      });
      return [
        { name: "API 11 In Board – Pressure (psi)", data: cPbar11 },
        {
          name: "API 11 Out Board – Pressure (psi)",
          data: fPbar11
        }
      ];
    },
    imapSHTc() {
      let shTc23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.shTf23];
      });
      return [{ name: "API 23 Stuffing Box Temperature (°F)", data: shTc23 }];
    },
    imapSHPbar() {
      let shPbar23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.shPpsi23];
      });
      return [{ name: "API 23 Stuffing Box Pressure (psi)", data: shPbar23 }];
    },
    imapFITc() {
      let fiTc23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.fiTf23];
      });
      return [{ name: "API 23 FI Temperature (°F) ", data: fiTc23 }];
    },
    imapCwTc() {
      let cwTinC23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.cwTinF23];
      });
      let cwToutC23 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI23.cwToutF23];
      });

      return [
        {
          name: "API 23 Cooling Water Out Temperature (°F) ",
          data: cwToutC23
        },
        { name: "API 23 Cooling Water In Temperature (°F) ", data: cwTinC23 }
      ];
    },
    imapfCTf() {
      let fiTfF32 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI32.fiTfF32];
      });
      let fiTfC32 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI32.fiTfC32];
      });
      return [
        { name: "API 32 Out Board Temperature (°F) ", data: fiTfF32 },
        { name: "API 32 In Board  Temperature (°F) ", data: fiTfC32 }
      ];
    },

    imapCwInOut52() {
      let cwInTc52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.cwInTf52];
      });
      let cwOutTc52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.cwOutTf52];
      });
      return [
        {
          name: "API 52 Cooling Water Temperature (°F) In ",
          data: cwInTc52
        },
        {
          name: "API 52 Cooling Water Temperature (°F) Out",
          data: cwOutTc52
        }
      ];
    },
    imapOilInOut52() {
      let oilInTc52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.oilInTf52];
      });
      let oilOutTc52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.oilOutTf52];
      });
      return [
        {
          name: "API 52 Oil Temperature (°F) In",
          data: oilInTc52
        },
        {
          name: "API 52 Oil Temperature (°F) Out",
          data: oilOutTc52
        }
      ];
    },

    imapShPbar52() {
      let shPbar52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.shPpsi52];
      });
      return [{ name: "API 52 Stuffing Box Pressure (psi)", data: shPbar52 }];
    },

    imapPBar52() {
      let pBar52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.pPsi52];
      });
      return [{ name: "API 52 Pressure (psi)", data: pBar52 }];
    },

    imapTankLevel52() {
      let level52 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI52.level52];
      });
      return [{ name: "API 52 Tank Level (mm)", data: level52 }];
    },

    imapIaPbar53b() {
      let iaPbar53b = this.measurements.map(function(obj) {
        return [
          obj.dateCreated.seconds * 1000,
          Math.round(obj.planAPI53b.iaPpsi53b)
        ];
      });
      return [
        { name: "API 53B Instrument Air Pressure (psi)", data: iaPbar53b }
      ];
    },

    imapSysPbar53b() {
      let sysPbar53b = this.measurements.map(function(obj) {
        return [
          obj.dateCreated.seconds * 1000,
          Math.round(obj.planAPI53b.sysPpsi53b)
        ];
      });
      return [{ name: "API 53B System Pressure (psi)", data: sysPbar53b }];
    },
    imapcBpiBpoTc53b() {
      let cBpiTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cBpiTf53b];
      });
      let cBpoTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cBpoTf53b];
      });
      return [
        {
          name: "API 53b In Board Bpo Temperature (°F)",
          data: cBpoTc53b
        },
        {
          name: "API 53b In Board Bpi Temperature (°F)",
          data: cBpiTc53b
        }
      ];
    },
    imapFCRs53b() {
      let fRsPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fRsPpsi53b];
      });
      let cRsPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cRsPpsi53b];
      });
      return [
        {
          name: "API 53b  Refilling Systems In Board - Pressure (psi)",
          data: fRsPbar53b
        },
        {
          name: "API 53b  Refilling Systems Out Board - Pressure (psi)",
          data: cRsPbar53b
        }
      ];
    },

    imapcBpiBpoBar53b() {
      let fBpoPpsi53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fBpoPpsi53b];
      });
      let cBpoPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cBpoPpsi53b];
      });
      return [
        {
          name: "API 53b Out Board Bpo Pressure (psi)",
          data: fBpoPpsi53b
        },
        {
          name: "API 53b In Board Bpo Pressure (psi)",
          data: cBpoPbar53b
        }
      ];
    },

    imapcCwInOut53b() {
      let cCwOutTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cCwOutTf53b];
      });
      let cCwInTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cCwInTf53b];
      });
      return [
        {
          name: "API 53b In Board Cooling Water Temperature (°F) Out",
          data: cCwOutTc53b
        },
        {
          name: "API 53b In Board Cooling Water Temperature (°F) In ",
          data: cCwInTc53b
        }
      ];
    },
    imapfBpiBpoTc53b() {
      let fBpiTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fBpiTf53b];
      });
      let fBpoTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fBpoTf53b];
      });
      return [
        {
          name: "API 53b Out Board  Bpo Temperature (°F)",
          data: fBpoTc53b
        },
        {
          name: "API 53b Out Board  Bpi Temperature (°F)",
          data: fBpiTc53b
        }
      ];
    },

    imapfBpiBpoBar53b() {
      let fBpoPbar53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.fBpoPpsi53b];
      });
      return [
        {
          name: "API 53b Out Board Bpo Pressure (psi)",
          data: fBpoPbar53b
        }
      ];
    },

    imapfCwInOut53b() {
      let cFwInTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cFwInTf53b];
      });
      let cFwOutTc53b = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI53b.cFwOutTf53b];
      });
      return [
        {
          name: "API 53b Out Board Cooling Water Temperature (°F) In ",
          data: cFwInTc53b
        },
        {
          name: "API 53b Out Board  Cooling Water Temperature (°F) Out",
          data: cFwOutTc53b
        }
      ];
    },
    imapBpiBpoTc54() {
      let bpiTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.bpiTf54];
      });
      let bpoTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.bpoTf54];
      });
      return [
        {
          name: "API 54 In Board BPO – Temperature (°F) ",
          data: bpoTc54
        },
        {
          name: "API 54 In Board BPI – Temperature (°F) ",
          data: bpiTc54
        }
      ];
    },

    imapBpiBpoPbar54() {
      let bpoPbar54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.bpoPpsi54];
      });
      let bpiPbar54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.bpiPpsi54];
      });
      return [
        {
          name: "API 54 In Board BPO – Pressure (psi) ",
          data: bpoPbar54
        },
        {
          name: "API 54 In Board BPI – Pressure (psi) ",
          data: bpiPbar54
        }
      ];
    },
    imapCwInOut54() {
      let cwInTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.cwInTf54];
      });
      let cwOutTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.cwOutTf54];
      });
      return [
        {
          name: "API 54 In Board Cooling Water Temperature (°F) Out",
          data: cwOutTc54
        },
        {
          name: "API 54 In Board Cooling Water Temperature (°F) In ",
          data: cwInTc54
        }
      ];
    },

    imapFlowL54() {
      let flowLpm54 = this.measurements.map(function(obj) {
        return [
          obj.dateCreated.seconds * 1000,
          Math.round(obj.planAPI54.flowGpm54)
        ];
      });
      return [{ name: "API 54 In Board Flow (Gal/min)", data: flowLpm54 }];
    },
    imapTankLevel54() {
      let levelL54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.levelL54];
      });
      return [{ name: "API 54 In Board Tank Level (l)", data: levelL54 }];
    },
    imapMotorTc54() {
      let motorTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.motorTf54];
      });
      return [
        { name: "API 54 In Board Motor Temperature (°F)", data: motorTc54 }
      ];
    },
    imapfBpiBpoTc54() {
      let bpiTf54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fbpiTf54];
      });
      let bpoTf54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fbpoTf54];
      });
      return [
        {
          name: "API 54 Out Board  BPO – Temperature (°F) ",
          data: bpoTf54
        },
        {
          name: "API 54 Out Board  BPI – Temperature (°F) ",
          data: bpiTf54
        }
      ];
    },

    imapfBpiBpoPbar54() {
      let bpoPbar54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fbpoPpsi54];
      });
      let bpiPbar54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fbpiPpsi54];
      });
      return [
        {
          name: "API 54 Out Board  BPO – Pressure (psi) ",
          data: bpoPbar54
        },
        {
          name: "API 54 Out Board  BPI – Pressure (psi) ",
          data: bpiPbar54
        }
      ];
    },
    imapfCwInOut54() {
      let fcwInTf54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fcwInTf54];
      });
      let fcwOutTf54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fcwOutTf54];
      });
      return [
        {
          name: "API 54 Out Board  Cooling Water Temperature (°F) Out",
          data: fcwOutTf54
        },
        {
          name: "API 54 Out Board  Cooling Water Temperature (°F) In ",
          data: fcwInTf54
        }
      ];
    },

    imapfFlowL54() {
      let flowLpm54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fflowGpm54];
      });
      return [{ name: "API 54 Out Board  Flow (Gal/min)", data: flowLpm54 }];
    },
    imapfTankLevel54() {
      let levelMm54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.flevelL54];
      });
      return [{ name: "API 54 Out Board  Tank Level (l)", data: levelMm54 }];
    },
    imapfMotorTc54() {
      let motorTc54 = this.measurements.map(function(obj) {
        return [obj.dateCreated.seconds * 1000, obj.planAPI54.fmotorTf54];
      });
      return [
        { name: "API 54 Out Board  Motor Temperature (°F)", data: motorTc54 }
      ];
    }
  },
  filters: {
    FixingDate: function(value) {
      return moment.unix(value.seconds).format("MMMM D YYYY, h:mm:ss a");
    }
  }
};
</script>

<style>
.apexcharts-tooltip {
  background: #f3f3f3;
  color: #c72a23;
}
</style>
